import script from "./theNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./theNotice.vue?vue&type=script&setup=true&lang=js"

import "./theNotice.vue?vue&type=style&index=0&id=c848a0fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c848a0fc"]])

export default __exports__